<template>
  <BaseButton
    v-bind="{ ...$attrs, ...$props }"
    type="secondary"
    class="text-neutral-700 dark:text-neutral-300 bg-neutral-200 dark:bg-neutral-700"
    :class="{ 'text-neutral-400': text }"
  >
    <slot />
  </BaseButton>
</template>

<script setup lang="ts">
import type { Props as ButtonProps } from "./BaseButton.vue";

defineProps<Omit<ButtonProps, "type">>();
</script>
